import React from "react";
import {
  Card,
  Row,
  Col,
  Tag,
  Typography,
  Divider,
  Space,
  List,
  Button,
  Popconfirm,
  Input,
  Avatar,
} from "antd";
import {
  DownSquareOutlined,
  UpSquareOutlined,
  SaveOutlined,
  EditOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const { TextArea } = Input;

const MemoTab = ({
  memoDataOld,
  setMemoDataOld,
  memoDataNew,
  showNoteOld,
  setShowNoteOld,
  showNoteNew,
  setShowNoteNew,
  editMemoOld,
  setEditMemoOld,
  remarkValueNew,
  setRemarkValueNew,
  roleId,
  postMemoNew,
  postMemoOld,
}) => {
  return (
    <>
      <Divider orientation="left">
        <Space>
          <Typography.Text
            strong
            onClick={() => setShowNoteOld(!showNoteOld)}
            style={{ cursor: "pointer" }}
          >
            ข้อมูลจาก "Smart-dev"
          </Typography.Text>
          <Tag
            color="blue"
            onClick={() => setShowNoteOld(!showNoteOld)}
            style={{ cursor: "pointer" }}
          >
            {!showNoteOld ? <DownSquareOutlined /> : <UpSquareOutlined />}
          </Tag>
        </Space>
      </Divider>

      {showNoteOld && memoDataOld && (
        <Card style={{ marginBottom: 8 }}>
          <Input.TextArea
            readOnly={editMemoOld}
            value={memoDataOld?.MEMO1}
            onChange={(e) =>
              setMemoDataOld({ ...memoDataOld, MEMO1: e.target.value })
            }
            autoSize
            style={{
              border: !editMemoOld ? "1.5px solid #ff4d4f" : undefined, // ✅ สีแดงเมื่อแก้ไข
              borderRadius: 6,
              transition: "border 0.3s",
              backgroundColor: !editMemoOld ? "#fff5f5" : "#fafafa", // ✅ พื้นหลังชมพูอ่อน
            }}
          />
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Space style={{ marginTop: 10 }}>
                {editMemoOld ? (
                  <Button
                    icon={<EditOutlined />}
                    onClick={() => setEditMemoOld(false)}
                    disabled={![1, 2, 3, 13].includes(roleId)}
                  >
                    แก้ไข
                  </Button>
                ) : (
                  <Button
                    danger
                    icon={<CloseOutlined />}
                    onClick={() => setEditMemoOld(true)}
                  >
                    ยกเลิก
                  </Button>
                )}
                <Popconfirm
                  placement="topLeft"
                  title="อัพเดทข้อมูลโปรแกรม Smart dev"
                  description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                  onConfirm={postMemoOld} // ✅
                  okText="ยืนยัน"
                  cancelText="ปิด"
                  okButtonProps={{ size: "large" }}
                  cancelButtonProps={{ size: "large" }}
                >
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    disabled={editMemoOld}
                  >
                    บันทึก
                  </Button>
                </Popconfirm>
              </Space>
            </Col>
          </Row>
        </Card>
      )}

      <Divider orientation="left">
        <Space>
          <Typography.Text
            strong
            onClick={() => {
              setShowNoteNew(!showNoteNew);
            }}
            style={{ cursor: "pointer" }}
          >
            ข้อมูลจาก "โปรแกรมใหม่"
          </Typography.Text>
          <Tag
            color="blue"
            onClick={() => {
              setShowNoteNew(!showNoteNew);
            }}
            style={{ cursor: "pointer" }}
          >
            {memoDataNew ? memoDataNew?.length : 0} รายการ{" "}
            {!showNoteNew ? <DownSquareOutlined /> : <UpSquareOutlined />}
          </Tag>
        </Space>
      </Divider>
      {showNoteNew && (
        <>
          <List
            style={{ marginBottom: 16, borderRadius: 8, overflow: "hidden" }}
            bordered
            dataSource={memoDataNew}
            locale={{ emptyText: "ไม่มีข้อมูลหมายเหตุ" }}
            renderItem={(item, index) => (
              <List.Item
                style={{
                  backgroundColor: index % 2 === 0 ? "#f0f7ff" : "#ffffff",
                  padding: "12px 16px",
                  alignItems: "flex-start",
                }}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#1890ff" : "#096dd9",
                        fontWeight: "bold",
                      }}
                    >
                      {item?.USERNAME?.charAt(0)?.toUpperCase()}
                    </Avatar>
                  }
                  title={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 4,
                      }}
                    >
                      <Space size={6}>
                        <Typography.Text strong style={{ color: "#1a365d" }}>
                          {item?.USERNAME}
                        </Typography.Text>
                        <Tag
                          color="blue"
                          style={{ borderRadius: 10, fontSize: 11 }}
                        >
                          {dayjs(item?.CreatedAt).format("DD/MM/YYYY HH:mm")}
                        </Tag>
                      </Space>
                      <Typography.Text
                        copyable={{
                          text: `${item?.note}\n ${dayjs(item?.CreatedAt).format("DD/MM/YYYY HH:mm")} [${item?.USERNAME}]`,
                          tooltips: ["คัดลอก", "คัดลอกแล้ว!"],
                        }}
                        style={{ fontSize: 12, color: "#888" }}
                      />
                    </div>
                  }
                  description={
                    <Typography.Text
                      style={{
                        fontSize: 13,
                        color: "#333",
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.7,
                      }}
                    >
                      {item?.note}
                    </Typography.Text>
                  }
                />
              </List.Item>
            )}
          />
          <TextArea
            placeholder="กรอกหมายเหตุ (ถ้ามี)"
            value={remarkValueNew}
            onChange={(e) => setRemarkValueNew(e.target.value)}
            rows={5}
            showCount
            maxLength={500}
            style={{ marginBottom: "20px" }}
          />
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Popconfirm
                placement="topLeft"
                title="อัพเดทข้อมูลโปรแกรมใหม่"
                description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย ไม่สามารถแก้ไขสิ่งที่ได้บันทึกได้!"
                onConfirm={postMemoNew} // ✅
                okText="ยืนยัน"
                cancelText="ปิด"
                okButtonProps={{ size: "large" }}
                cancelButtonProps={{ size: "large" }}
              >
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  disabled={!remarkValueNew}
                >
                  บันทึก
                </Button>
              </Popconfirm>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default MemoTab;
